import SnackCard from './snackCard'

export default SnackCard